import 'css-chunksrc/client/scenes/task/details/styles.scss';export default {
  "details": "_details_bnbnj_1",
  "name": "_name_bnbnj_5",
  "taskCompletion": "_taskCompletion_bnbnj_15",
  "input": "_input_bnbnj_22",
  "description": "_description_bnbnj_32",
  "label": "_label_bnbnj_36",
  "paragraph": "_paragraph_bnbnj_46",
  "advancement": "_advancement_bnbnj_56",
  "percentage": "_percentage_bnbnj_63",
  "progressBar": "_progressBar_bnbnj_72",
  "percentageText": "_percentageText_bnbnj_77",
  "advancementLabel": "_advancementLabel_bnbnj_86",
  "descriptionMaxChars": "_descriptionMaxChars_bnbnj_93",
  "loader": "_loader_bnbnj_98",
  "loaderMain": "_loaderMain_bnbnj_106",
  "invalid": "_invalid_bnbnj_113",
  "container": "_container_bnbnj_121",
  "item": "_item_bnbnj_128",
  "value": "_value_bnbnj_139",
  "tagsValue": "_tagsValue_bnbnj_149"
};